<template>
    <app-page title="Relatório de vendas por produto" :subtitle="subtitle">
        
        <b-button slot="actions" icon-left="print" @click="print" class="is-hidden-print" rounded>Imprimir</b-button>

        <form @submit.prevent="generateReport" class="columns is-middle is-hidden-print">
            <div class="column">
                <b-field label="Início">
                    <b-input type="date" v-model="filter.startDate"/>
                </b-field>
            </div>
            <div class="column">
                <b-field label="Fim">
                    <b-input type="date" v-model="filter.endDate"/>
                </b-field>
            </div>
            <div class="column is-narrow">
                <button type="submit" class="button is-primary is-rounded">Filtrar</button>
            </div>
        </form>

        <table class="table is-fullwidth is-striped">
            <thead>
            <tr>
                <th>Produto</th>
                <th>Quantidade</th>
                <th>Preço</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(product, key) in productsArray" :key="key">
                <td>{{ product.name }}</td>
                <td>
                    <convertUnit :value="product.quantity" :current-unit="product.measureUnit"/>
                </td>
                <td>{{ product.price | money }}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr class="has-text-weight-bold">
                <td>Total</td>
                <td></td>
                <td>{{ totalPrice | money}}</td>
            </tr>
            </tfoot>
        </table>

    </app-page>
</template>

<script>
    import moment from 'moment';
    import AppPage from "../../../components/AppPage";
    import convertUnit from "../../products/components/convertUnit";
    import functions from "../../../services/functions";

    export default {
        name: "productSaleReportPage",

        components: {AppPage, convertUnit},

        data() {
            return {
                filter: {
                    startDate: moment().subtract(1, 'week').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD'),
                },
                products: null
            }
        },

        computed: {
            subtitle() {
                const startDate = moment(this.filter.startDate).format('LL');
                const endDate = moment(this.filter.endDate).format('LL');
                return `${startDate} até ${endDate}`;
            },

            productsArray() {
                const products = this.products;
                const productsArray = Object.keys(products || {}).map((key) => {
                    return products[key]
                });

                productsArray.sort((a, b) => {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });

                return productsArray;
            },
            
            totalPrice() {
                let price = 0;
                this.productsArray.forEach((product) => {
                    price += parseFloat(product.price);
                });

                return price;
            }
        },

        methods: {
            async generateReport() {
                const loading = this.$buefy.loading.open();
                const start = moment(this.filter.startDate).toDate().getTime();
                const end = moment(this.filter.endDate).add('23','h').add('59','m').toDate().getTime();
                
                const productSalesReport = functions.httpsCallable('productSalesReport');
                const products = await productSalesReport({start, end});
                this.products = products.data;

                loading.close();
            },
            
            print(){
                window.print()
            }
        },

        created() {
            this.generateReport()
        }
    }
</script>